import { getSharedKeyboardLayout } from 'zycommon-web/utils/symbolic-tools/shared-keyboard-layouts';

/**
 * Get the Symbolic Equivalence virtual keyboard layout.
 * @param {Object} commonKeys The common keys used across different virtual keyboard layouts.
 * @param {SymbolicShortAnswerQuestion} symbolicQuestion The symbolic short answer question containing the necessary tool-specific properties.
 * @param {Array} symbolicQuestion.virtual_keyboard_layout_name The specific virtual keyboard layout used in the question.
 * @returns {Array} The keyboard layout.
 */
export function getSymbolicEquivalenceKeyboardLayout(commonKeys, symbolicQuestion) {
    const { virtual_keyboard_layout_name } = symbolicQuestion;

    // Try to get the shared keyboard layout// Try to get the shared keyboard layout
    const sharedLayout = getSharedKeyboardLayout(commonKeys, virtual_keyboard_layout_name);

    // If a shared layout exists, return it
    if (sharedLayout) {
        return sharedLayout;
    }

    // Otherwise, return kitchen sink
    return ['numeric', 'symbols', 'alphabetic', 'greek'];
}
